<template>
    <v-container>
        <v-row class="mt-6">
            <v-col cols="12" md="8" offset-md="2">
                <v-card class="card-container kimsa-elevation">
                    <v-card-title class="title-container">
                        {{ $t('common.account_disabled') }}
                    </v-card-title>
                    <v-card-text class="mt-9">
                        <v-alert icon="mdi-alert-circle-outline" dark color="error" border="left">
                            <div v-html="currentError"/>
                        </v-alert>
                    </v-card-text>
                    <v-card-actions class="pa-0">
                        <v-row no-gutters>
                            <v-col cols="12" md="6">
                                <v-btn block depressed x-large color="primary" class="normal-btn no-radius black--text" @click="goToPlan">
                                    {{ $t('common.select_new_plan') }}
                                </v-btn>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-btn block depressed x-large color="primary" class="normal-btn no-radius black--text" @click="goToCard">
                                    {{ $t('common.change_payment_method') }}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: "DisabledAccount",
    computed: {
        currentError(vm = this) {
            let last4 = vm.account?.stripeAccount?.last4 || null
            let defaultMessage = vm.$t('payment_failed_messages.try_again_later')
            let failedReason = vm.account?.stripeAccount?.failedReason || null
            let reason = vm.$te(`payment_failed_messages.${failedReason}`) ?
                vm.$t(`payment_failed_messages.${failedReason}`) : defaultMessage
            if (last4) return vm.$t('payment_failed_messages.last_card', {last4}) + '<br>' + reason
            return vm.$t('coach.payment_method_required')
        },
    },
    methods: {
        goToPlan() {
            const vm = this
            vm.$router.push({name: `${vm.accountType}.select-plan`})
        },
        goToCard() {
            const vm = this
            vm.$router.push({name: `${vm.accountType}.credit-card`})
        },
    }
}
</script>

<style scoped>

.card-container {
    border-radius: 8px;
    overflow: hidden;
}

.title-container {
    color: #FFFFFF;
    background: var(--v-backGroundPrimary-base);
}

</style>